export default __webpack_public_path__ + "4cc994d1c6bedc87b30329a04271c2ed.png";